import { v7 as uuidv7 } from "uuid";

export const uuidV7 = () => uuidv7();
